import { render } from "./lta.vue?vue&type=template&id=2f731537&scoped=true"
import script from "./lta.vue?vue&type=script&lang=js"
export * from "./lta.vue?vue&type=script&lang=js"

import "./lta.vue?vue&type=style&index=0&id=2f731537&scoped=true&lang=css"

import exportComponent from "/Users/arissa/Desktop/code/portfolio/arissa-portfolio/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f731537"]])

export default __exports__